import { VTextComponent } from './vText';
import { VCheckboxComponent } from './vCheckbox';
import { VURLComponent } from './vURL';
import { VEmailComponent } from './vEmail';
import { VRadioComponent } from './vRadio';
import { VColorComponent } from './vColor';
import { VRangeComponent } from './vRange';
import { VDateComponent } from './vDate';

export {
  VTextComponent,
  VCheckboxComponent,
  VURLComponent,
  VEmailComponent,
  VRadioComponent,
  VColorComponent,
  VRangeComponent,
  VDateComponent,
};
